require('./vanilla/cart');

const AddressLookup = () => import('./components/AddressLookup');
Vue.component('AddressLookup', AddressLookup);

const SearchBox = () => import('./sections/search/SearchBox');
Vue.component('SearchBox', SearchBox);

const GlobalCart = () => import('./components/GlobalCart');
Vue.component('GlobalCart', GlobalCart);

const CartIcon = () => import('./components/CartIcon');
Vue.component('CartIcon', CartIcon);

const Carousel = () => import('./components/Carousel');
Vue.component('Carousel', Carousel);

const ProductCarousel = () => import('./components/ProductCarousel');
Vue.component('ProductCarousel', ProductCarousel);

const Toast = () => import('./components/ToastPopop');
Vue.component('Toast', Toast);

const FindAStockist = () => import('./sections/stockist/FindAStockist');
Vue.component('FindAStockist', FindAStockist);

const Testimonials = () => import('./sections/testimonial/Testimonials');
Vue.component('Testimonials', Testimonials);


const ProductPrice = () => import('./sections/product/ProductPrice');
Vue.component('ProductPrice', ProductPrice);

const ProductSubscriptions = () => import('./sections/product/ProductSubscriptions');
Vue.component('ProductSubscriptions', ProductSubscriptions);

const ProductSubscription = () => import('./sections/product/ProductSubscription');
Vue.component('ProductSubscription', ProductSubscription);

const ProductFrozenInfo = () => import('./sections/product/ProductFrozenInfo');
Vue.component('ProductFrozenInfo', ProductFrozenInfo);

const ProductFrozenInfoMobile = () => import('./sections/product/ProductFrozenInfoMobile');
Vue.component('ProductFrozenInfoMobile', ProductFrozenInfoMobile);

const ProductMultipackSelector = () => import('./sections/product/ProductMultipackSelector');
Vue.component('ProductMultipackSelector', ProductMultipackSelector);

const ProductMultipackItem = () => import('./sections/product/ProductMultipackItem');
Vue.component('ProductMultipackItem', ProductMultipackItem);

const Braintree = () => import('./components/Braintree');
Vue.component('Braintree', Braintree);

const Cart = () => import('./sections/cart/Cart');
Vue.component('Cart', Cart);

const GuestPayment = () => import('./sections/cart/GuestPayment');
Vue.component('GuestPayment', GuestPayment);

const UserPayment = () => import('./sections/cart/UserPayment');
Vue.component('UserPayment', UserPayment);

const DropIn = () => import('./sections/cart/DropIn');
Vue.component('DropIn', DropIn);


const PetWizard = () => import('./sections/pet-wizard/PetWizard');
Vue.component('PetWizard', PetWizard);

const BrandWizard = () => import('./sections/brand-wizard/BrandWizard');
Vue.component('BrandWizard', BrandWizard);

const BrandBestSeller = () => import('./sections/brand-wizard/BrandBestSeller');
Vue.component('BrandBestSeller', BrandBestSeller);

const BrandBestSellerCarousel = () => import('./sections/brand-wizard/BrandBestSellerCarousel');
Vue.component('BrandBestSellerCarousel', BrandBestSellerCarousel);

const SearchPage = () => import('./sections/search/SearchPage');
Vue.component('SearchPage', SearchPage);

const SearchPageNmuk = () => import('./sections/search/SearchPageNMUK');
Vue.component('SearchPageNmuk', SearchPageNmuk);

const SearchPageFreezer = () => import('./sections/search/SearchPageFreezer');
Vue.component('SearchPageFreezer', SearchPageFreezer);

const SearchPageTrade = () => import('./sections/search/SearchPageTrade');
Vue.component('SearchPageTrade', SearchPageTrade);

const SearchPagePos = () => import('./sections/search/SearchPagePos');
Vue.component('SearchPagePos', SearchPagePos);

const SearchPageTopThirty = () => import('./sections/search/SearchPageTopThirty');
Vue.component('SearchPageTopThirty', SearchPageTopThirty);

const PermissionFormElement = () => import('./sections/form/Permissions');
Vue.component('PermissionFormElement', PermissionFormElement);

const RoleFormElement = () => import('./sections/form/Roles');
Vue.component('RoleFormElement', RoleFormElement);

const EditCustomer = () => import('./sections/customer/Edit');
Vue.component('EditCustomer', EditCustomer);


const HomepageProducts = () => import('./components/HomepageProducts');
Vue.component('HomepageProducts', HomepageProducts);

const TestimonialCarousel = () => import('./components/TestimonialCarousel');
Vue.component('TestimonialCarousel', TestimonialCarousel);

const FlipImage = () => import('./components/FlipImage');
Vue.component('FlipImage', FlipImage);

const Faq = () => import('./sections/faq/Faq');
Vue.component('Faq', Faq);

const CreateAccount = () => import('./sections/auth/CreateAccount');
Vue.component('CreateAccount', CreateAccount);

const PaymentMethodForm = () => import('./components/PaymentMethodForm');
Vue.component('PaymentMethodForm', PaymentMethodForm);

// Blog
const BlogSearch = () => import('./sections/blog/BlogSearch');
Vue.component('BlogSearch', BlogSearch);

// Edi
const CustomerMappingForm = () => import('./sections/edi/customer-mapping/customerMappingForm');
Vue.component('CustomerMappingForm', CustomerMappingForm);

const TrackingNew = () => import('./sites/tracking/core/components/Tracking.vue');
Vue.component('TrackingNew', TrackingNew);

const TrackingMapNew = () => import('./sites/tracking/core/components/TrackingMap.vue');
Vue.component('TrackingMapNew', TrackingMapNew);